export default {
  path: '/error',
  component: () => import('@views/Default/Index'),
  beforeEnter: (to, from, next) => {
    next()
  },
  children: [
    {
      path: '401',
      name: '401',
      component: () => import('@/components/Default/401')
    },
  ]
}
